/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=Editor&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=Editor&lang=js"

import "./index.vue?vue&type=style&index=0&id=5b27d1cc&scoped=true&lang=scss"

import exportComponent from "E:\\new-admin\\3.0\\ruoyi-vue3-cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b27d1cc"]])

export default __exports__